import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import './MainSidebar.scss'

interface Props {
  menu: any[]
}

const SidebarItem = ({ item }: { item: any }) => {
  const content = (
    <>
      <span className="pl4-main-sidebar__icon" aria-hidden="true">
        <span className={`${item.icon}${item.active ? '_full' : ''}`} />
      </span>
      <span className="pl4-main-sidebar__label">{item.text}</span>
    </>
  )

  return (
    <li>
      {item.disabled ? (
        <span
          aria-disabled="true"
          className={`pl4-main-sidebar__item${item.active ? ' is-active' : ''} is-disabled`}
          title={item.text}
        >
          {content}
        </span>
      ) : (
        <Link
          aria-current={item.active ? 'page' : undefined}
          className={`pl4-main-sidebar__item${item.active ? ' is-active' : ''}`}
          title={item.text}
          to={item.path}
        >
          {content}
        </Link>
      )}
    </li>
  )
}

const MainSidebar = ({ menu }: Props) => {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const mainItems = menu.filter((item: any) => !item.alignRight)
  const bottomItems = menu.filter((item: any) => item.alignRight)

  if (!menu.length) return null

  return (
    <aside className={`pl4-main-sidebar${isCollapsed ? ' is-collapsed' : ''}`}>
      <nav aria-label="Navegación principal" className="pl4-main-sidebar__nav">
        <ul className="pl4-main-sidebar__list">
          {mainItems.map((item: any) => <SidebarItem item={item} key={item.text} />)}
        </ul>
        <ul className="pl4-main-sidebar__list pl4-main-sidebar__list-bottom">
          {bottomItems.map((item: any) => <SidebarItem item={item} key={item.text} />)}
        </ul>
      </nav>
      <button
        aria-label={isCollapsed ? 'Expandir menú' : 'Contraer menú'}
        className="pl4-main-sidebar__toggle"
        onClick={() => setIsCollapsed((collapsed) => !collapsed)}
        title={isCollapsed ? 'Expandir menú' : 'Contraer menú'}
        type="button"
      >
        <i className={`fas fa-chevron-${isCollapsed ? 'right' : 'left'}`} aria-hidden="true" />
        <span className="pl4-main-sidebar__label">Contraer menú</span>
      </button>
    </aside>
  )
}

export default MainSidebar
